import gql from "graphql-tag";
export const planFragment = gql `
  fragment upsells_planFragment on PlanV2 {
    amount
    hasMeteredBilling
    hasMultiStepZaps
    hasPaths
    hasPremiumApps
    id
    interval
    name
    premiumAppsLimit
    tasks
    type
    zapLimit
  }
`;
export const accountFragment = gql `
  fragment upsells_accountFragment on Account {
    companyAccountEndDate
    companyName
    currency
    currentUserRole
    enabledTrialExtensions
    featureEnrollmentList {
      featureName
      id
      isEnrolled
    }
    hasBeenInCompaniesTrial
    id
    isTrialing
    isTrialingCompanies
    isTrialingTeams
    name
    owner {
      email
      id
      name
    }
    periodEndDate
    periodStartDate
    plan: planV2 {
      ...upsells_planFragment
    }
    planGroupId
    taskBufferOverride
    usage {
      tasks {
        total
        limit
      }
    }
  }
  ${planFragment}
`;

// @zapier/upsells@8.0.3 (1de7a616e)
